import { ComponentStore } from '@ngrx/component-store';


export interface MiniOperationsState {
    readonly id: number;
    readonly indexToDelete?: number;

}

export class MiniOperationsStore extends ComponentStore<MiniOperationsState> {

    constructor() {

        super({
            id: 0
        });
    }
    readonly id$ = this.select(({ id }) => id);
    // readonly indexToDelete$ = this.select(({ indexToDelete }) => indexToDelete);



    readonly updateId = this.updater((state, id: number) => ({
        ...state,
        id
    }));
    readonly deleteQuestion = this.updater((state, index: number | undefined) => ({
        ...state,
        indexToDelete: index
    }));

    // readonly addToCollection = this.effect<Question[]>(
    //     pipe(
    //       tap((users) => this.saveContact(users)),
    //       withLatestFrom(this.questionnaire$),
    //       // filter(([_,q])=>q!=undefined),
    //       switchMap(([_, q]) =>
    //         this.#questionnaireApiService.save(q).pipe(
    //           tapResponse(
    //             (response) => {
    //               this.patchState({ loading: false, recentlySave: new Date(),questionnaireId:response.id })},
    //             (error: Error) =>
    //               this.patchState({ error: error?.message, loading: false })
    //           )
    //         )
    //       )
    //     )
    //   );
}